<script setup>
</script>

<template>
  <section class="section">
    <div class="wrap" style="text-align:center; display:grid; gap:16px;">
      <h1>Pagina niet gevonden</h1>
      <p>De pagina die je zocht bestaat niet (meer).</p>
      <router-link class="btn btn-primary" to="/">Terug naar home</router-link>
    </div>
  </section>
</template>
